export const ENDPOINT_GENERATE = '/api/ai/poem';
export const ENDPOINT_STATUS = '/api/ai/poem_status';
export const JOB_TOKEN_HEADER = 'X-Job-Token';

// a poem takes 5–6 s: the first look comes a little later than a greeting's
export const POLL_BASE_MS = 1500;
export const POLL_BACKOFF_MS = 300;
export const POLL_MAX_MS = 3000;
// the server sends its own wait (`waitSeconds`, PoemConfig::CLIENT_WAIT_SEC);
// this is only for an answer that lacks it
export const DEFAULT_WAIT_SEC = 45;

// Yandex Metrika (doc/metrika-goals.md, «AI poem by phrases»)
export const GOAL_GENERATE = 'ai-poem-generate';
export const GOAL_READY = 'ai-poem-ready';
export const GOAL_FAIL = 'ai-poem-fail';

export const SELECTOR_ROOT = '[data-ai-poem]';
export const SELECTOR_COMPOSE = '[data-ai-poem-compose]';
export const SELECTOR_STATUS = '[data-ai-poem-status]';
export const SELECTOR_STANZAS = '[data-ai-poem-stanzas]';
export const SELECTOR_STANZA = 'textarea[data-role="poem_part"]';
export const selectorForRole = (role: string): string =>
    `[name="subtitle"][data-role="${role}"]`;

export const CLASS_BUSY = 'is-busy';
// the stanzas' appear animation, for the moment the script opens them
export const CLASS_REVEALED = 'is-revealed';
export const CLASS_ATTENTION = 'is-attention';
export const ATTENTION_MS = 1600;

export const COPY = {
    composing: 'Сочиняем…',
    working: 'Сочиняем стих, это займёт несколько секунд',
    queued: (position: number, seconds?: number): string =>
        `Стих в очереди: перед ним ${position}` +
        (seconds ? `, примерно ${seconds} с` : ''),
    needPrompt: 'Сначала опишите, о ком и о чём стих',
    needPoem: 'Сначала сочините стих – кнопка под описанием',
    writeOrCompose: 'Напишите стих в полях ниже или сочините его кнопкой',
    fillAllStanzas: 'Допишите стих: одна из строф пустая',
    stillComposing: 'Подождите, стих ещё сочиняется',
    inputsChanged: 'Описание изменилось – сочинить заново?',
    confirmReplaceEdited:
        'Стих правили вручную. Сочинить новый вместо него? Правки пропадут.',
    confirmReplaceSaved: 'Сочинить новый стих вместо нынешнего?',
    writeYourself: 'Можно написать стих самим – поля ниже.',
    failed: 'Не получилось сочинить стих.',
    unavailable: 'Сочинение стихов сейчас недоступно.',
    timeout: 'Стих не успел сочиниться.',
    rejected: 'Не получилось отправить описание. Обновите страницу.',
    off: 'Сочинение стихов сейчас выключено.',
    busy: 'Предыдущий стих ещё сочиняется – подождите несколько секунд и нажмите снова.',
    mismatch: 'Пришёл стих не для этой открытки.',
    stanzaNoWords:
        'В строфе одни смайлики – на открытке она выйдет пустой. Добавьте слова.',
    badPrompt:
        'Описание не подошло: уберите из него телефоны, почту и длинные ряды цифр или сократите его.',
    badName:
        'Имя не подошло: уберите из него телефоны, почту и цифры или сократите его.',
    stanzaTooLong:
        'Строфа длиннее, чем теперь помещается в открытку: сократите её или сочините стих заново.',
    limitDaily: 'На сегодня стихи закончились, завтра можно снова.',
    limitHourly: 'Слишком много стихов за час, попробуйте позже.',
    limitBusy: 'Сейчас очень много желающих, попробуйте через несколько минут.',
    tryAgain: 'Попробуйте ещё раз.',
} as const;
